var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayByBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: "\\u2699    as-di as-r as-s as-t as-aq as-1k as-1l as-4i as-7c \\u26991q16c7l",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D8DEE4",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#474E5A",
    fillRule: "evenodd",
    d: "M24.251 11.671c.458.243.632.81.39 1.268l-2.084 3.936h1.675c.941 0 1.545 1 1.107 1.832l-2.884 5.48a.937.937 0 1 1-1.66-.874l2.402-4.563H21.52a1.25 1.25 0 0 1-1.105-1.835l2.57-4.854a.938.938 0 0 1 1.267-.39Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#474E5A",
    d: "M15.592 5.093a.938.938 0 0 1 .799-.008l7.5 3.438a.937.937 0 1 1-.782 1.704L16.01 6.974 7.875 10.9v.974h10c.053 0 .105.004.156.013a.937.937 0 0 1 1.094.925v7.5a.937.937 0 1 1-1.875 0V13.75h-2.5v6.563a.937.937 0 1 1-1.875 0V13.75H11v6.563c0 .355-.2.68-.518.838l-2.607 1.303v.671h10.313a.937.937 0 1 1 0 1.875H7.25C6.56 25 6 24.44 6 23.75v-1.682c0-.473.268-.906.691-1.118l2.434-1.217V13.75H7.25c-.69 0-1.25-.56-1.25-1.25v-1.991c0-.48.275-.917.707-1.126l8.885-4.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayByBank);
export default __webpack_public_path__ + "static/media/PAY_BY_BANK.e1ed7c82c5d2b487de75c617c2de23a3.svg";
export { ForwardRef as ReactComponent };